// https://github.com/cachecontrol/json-rules-engine/blob/HEAD/docs/rules.md#operators

export enum STRING_OPERATORS {
  equal = "equal",
  notEqual = "notEqual",
  contains = "contains",
  length = "length",
}
